import { useContext } from 'react'
import { AnalyticContext } from '@contexts/index'

export const useAnalyticContext = () => useContext(AnalyticContext)
